import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs } from "../components";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { useRecoilState } from "recoil";
import { cartItemsJSON } from "../states/atoms/store";
import { StoreContext } from "../context";
import Select from "react-select";
import wilaya from "../assets/json/wilaya.json";
import wilaya_ar from "../assets/json/wilaya_ar.json";
import ReCaptchaV2 from "react-google-recaptcha";
import axios from "axios";
import { API_BASE_URL, BASE_URL, REACT_APP_SITE_KEY } from "../constant";
import { useTranslation } from "react-i18next";
import { Salary,PremiumClient } from "../states/atoms/simulator";
import proxima from "../assets/bank-assets/proxima.png"

// import ReactGA from "react-ga4";

export default function Checkout() {
  const [cartItems, setCartItems] = useRecoilState(cartItemsJSON);
  const [loeading, setLeading] = useState(false);
  const [name, setName] = useState("");
  const [salarySimulator, setSalarySimulator] = useRecoilState(Salary);
  const [isPremiumClient, setISPremiumClient] = useRecoilState(PremiumClient);
  const [cheked, setCheked] = useState(true);
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [website, setWebsite] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [notes, setNotes] = useState("");
  const [description, setDescription] = useState("");
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [amount, setAmount] = useState("");
  const [list, setList] = useState([]);
  const [ville, setVille] = useState([]);
  const [total, setTotal] = useState(0);
  const [width] = useState(641);
  const [orderDetailCreateDtos, setOrderDetailCreateDtos] = useState([]);
  const [jsonData, setJsonData] = useState([]);
  const { cart, setCart } = useContext(StoreContext);
  // checkbox
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isPrivacyChecked, setIsPrivacyChecked] = useState(false);
  const [isCaptchaChecked, setIsCaptchaChecked] = useState(false);
  const [clientIpAddress, setClientIpAddress] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  var json = {};
  const phoneRegExp =
    /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

  const recaptchaRef = React.createRef();

  useEffect(() => {
    function orderDetailCreate() {
      cart.map((column) => {
        //todo:probleme sen id variantes as json data
        json = {
          varianteId: column.variantes[column.colorIndex].id,
          quantity: column.amount,
        };
        jsonData.push(json);
      });
      return jsonData;
    }

    function getIpAddress() {
      axios.get(`${API_BASE_URL}api/customer/getipaddress`).then((response) => {
        setClientIpAddress(response.data.ipAddress);
        // console.log(response.data.ipAddress)
      });
    }

    getIpAddress();
    orderDetailCreate();
  }, []);

  const defaultOption = ville[0];

  const CreateOrderSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, "Trop court !")
      .max(50, "Trop long !")
      .required("Obligatoire"),
    phone: Yup.string()
      .matches(phoneRegExp, "Le numéro de téléphone n'est pas valide")
      .required("Obligatoire"),
    address: Yup.string().required("Obligatoire"),
    email: Yup.string().required("Obligatoire"),
  });
  const CreateOrderSchema_ar = Yup.object().shape({
    name: Yup.string()
      .min(2, "قصير جدا !")
      .max(50, "طويلة جدا !")
      .required("إجباري"),
    phone: Yup.string()
      .matches(phoneRegExp, "رقم الهاتف غير صالح")
      .required("إجباري"),
    address: Yup.string().required("إجباري"),
    email: Yup.string().required("إجباري"),
  });

  // useEffect()
  // useEffect()
  function createOrder(values) {
    const recaptchaValue = recaptchaRef.current.getValue();
    if (recaptchaValue.length > 0) {
      setLeading(true);
      axios
        .post(`${API_BASE_URL}api/orders/orderf2`, {
          customer: {
            name: values.name,
            email: values.email,
            phone: values.phone,
            address: values.address,
            birthDay: "2022-08-01T00:00:00",
            wilaya: ville.label,
            netMonthlySalary: salarySimulator,
          },
          BankId: "08db5ad1-2afd-49f8-89ce-ff118b9b3dcf",  //  TODO: change the bank id
          // BankId: "08dc6ea1-ab80-44eb-8fb7-bc0f129b3693",  //  TODO:original in production
          orderDetailCreateDtos: jsonData,
          ClientIpAddress: clientIpAddress,
          TermsChecked: isTermsChecked ,
          PrivacyChecked: isPrivacyChecked,
          proximaDelevery: isSelected,
        })
        .then(function (response) {
          setCartItems([]);
          setCart([]);
          localStorage.clear();

          window.location.replace(`/invoice/${response.data.entity.id}`);
        })
        .catch(function (error) {
          console.log("Error Request!");
          setLeading(false);
        });
    }
  }
  const handleClick = () => {
    // console.log("are we selected delevry by proxima ?>", isSelected)
    if (isSelected) {
      setIsSelected(false)
    } else {
      setIsSelected(true)
    }
  };
  function onChange(value) {
    // console.log('Captcha value:', value)
    setIsCaptchaChecked(true);
  }

  // eslint-disable-next-line
  const { t, i18n } = useTranslation();

  //todo:recaptch functions
  const handleToken = (token) => {
    // setForm((currentForm) => {
    //     return {...currentForm, token }
    // })
  };

  const verifyCallback = (response) => {
    // console.log('verifyCallback', response)
  };

  const callback = () => {
    // console.log('Done!!!!')
  };
  // const toggleCheckbox = () => {
  //   setIsChecked((prevState) => !prevState);
  // };
  const toggleTermsCheckbox = () => {
    setIsTermsChecked(!isTermsChecked);
  };
  
  const togglePrivacyCheckbox = () => {
    setIsPrivacyChecked(!isPrivacyChecked);
  };

  const handleExpire = () => {
    // setForm((currentForm) => {
    //     return {...currentForm, token: null }
    // })
  };

  return (
    <>
      {loeading && <div className="loading-overlay">
        <div className="loading-spinner"></div>
      </div>}
      {i18n.language === "fr" ? (
        <Breadcrumbs>
          <Link to="/">{t("navbar.home")}</Link>
          {t("navbar.checkout")}
        </Breadcrumbs>
      ) : (
        <Breadcrumbs>
          {t("navbar.checkout")}
          <Link to="/">{t("navbar.home")}</Link>
        </Breadcrumbs>
      )}
      <br />
      <hr />
      <br />
      <div>
        <section className=" py-1 bg-blueGray-50">
          <div className="w-full lg:w-8/12 px-4 mx-auto mt-6">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
              {i18n.language === "fr" ? (
                <>
                  <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                      <h6 className="text-blueGray-700 text-xl font-bold">
                        {t("checkout.generate")}
                      </h6>
                    </div>
                  </div>
                  <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                    {/*todo:formik form*/}
                    <Formik
                      initialValues={{
                        livraison: false,
                        email: "",
                        name: "",
                        phone: "",
                        address: "",
                      }}
                      onSubmit={(values, formikBag) => {
                        createOrder(values, formikBag);
                      }}
                      validationSchema={
                        i18n.language === "fr"
                          ? CreateOrderSchema
                          : CreateOrderSchema_ar
                      }
                    >
                      {({ errors, touched }) => (
                        <Form>
                          <div className="max-w-4xl mx-auto p-6">
                            <h2 className="text-2xl font-bold text-primary-color mb-8">
                              {t("checkout.form.title")}
                            </h2>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              {/* Name Field */}
                              <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                  {t("checkout.form.fullName")} *
                                </label>
                                <Field name="name">
                                  {({ field, meta }) => (
                                    <div>
                                      <input
                                        {...field}
                                        type="text"
                                        placeholder="Nom et prénom"
                                        className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-color focus:border-primary-color transition-all"
                                      />
                                      {meta.touched && meta.error && (
                                        <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                      )}
                                    </div>
                                  )}
                                </Field>
                              </div>

                              {/* Email Field */}
                              <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                  {t("checkout.form.email")}
                                </label>
                                <Field name="email">
                                  {({ field, meta }) => (
                                    <div>
                                      <input
                                        {...field}
                                        type="email"
                                        placeholder="example@gmail.com"
                                        className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-color focus:border-primary-color transition-all"
                                      />
                                      {meta.touched && meta.error && (
                                        <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                      )}
                                    </div>
                                  )}
                                </Field>
                              </div>

                              {/* Phone Field */}
                              <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                  {t("checkout.form.phone")} *
                                </label>
                                <Field name="phone">
                                  {({ field, meta }) => (
                                    <div>
                                      <input
                                        {...field}
                                        type="tel"
                                        placeholder="+213 5 xx xx xx xx"
                                        className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-color focus:border-primary-color transition-all"
                                      />
                                      {meta.touched && meta.error && (
                                        <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                      )}
                                    </div>
                                  )}
                                </Field>
                              </div>

                              {/* Address Field */}
                              <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                  {t("checkout.form.address")} *
                                </label>
                                <Field name="address">
                                  {({ field, meta }) => (
                                    <div>
                                      <input
                                        {...field}
                                        type="text"
                                        placeholder="Bordj Bou Arreridj"
                                        className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-color focus:border-primary-color transition-all"
                                      />
                                      {meta.touched && meta.error && (
                                        <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                      )}
                                    </div>
                                  )}
                                </Field>
                              </div>

                              {/* Wilaya Field */}
                              <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">
                                  {t("checkout.form.wilaya")}
                                </label>
                                <Field name="wilaya">
                                  {({ form, meta }) => (
                                    <div>
                                      <Select
                                        options={wilaya}
                                        onChange={(value) => setVille(value)}
                                        className="w-full border rounded-lg focus:ring-2 focus:ring-primary-color"
                                        styles={{
                                          control: (base) => ({
                                            ...base,
                                            padding: '0.5rem',
                                            border: 'none',
                                            boxShadow: 'none'
                                          })
                                        }}
                                      />
                                      {meta.touched && meta.error && (
                                        <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                      )}
                                    </div>
                                  )}
                                </Field>
                              </div>
                              {/* reCAPTCHA */}
                              <div className="space-y-2">
                                <div className="scale-110 w-[320px] h-[80px]">

                                  <ReCaptchaV2
                                    sitekey={REACT_APP_SITE_KEY}
                                    ref={recaptchaRef}
                                    onChange={onChange}
                                    className="flex justify-center "
                                  />
                                </div>
                              </div>

                              {/* Proxima Delivery Card */}
                              <div className="md:col-span-3 gap-4">
                                <label className="flex items-center space-x-4 cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={handleClick}
                                    className="h-5 w-5 text-primary-color focus:ring-primary-color rounded border-gray-300"
                                  />
                                  <div className={`p-4 rounded-lg flex items-center space-x-4 transition ${isSelected ? "bg-blue-200 border-primary-color" : "bg-white border-gray-300"
                                    }`}>
                                    <div>
                                      <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                                        Livraison
                                        <img
                                          src={proxima}
                                          alt="Proxima Delivery"
                                          className="w-16 h-16 object-contain inline-block" // Smaller, inline image
                                        />
                                        <span className="inline-block ml-2 px-2 py-1 bg-primary-color text-white text-xs rounded-full">
                                          Gratuit
                                        </span>
                                      </h3>
                                    </div>
                                  </div>
                                </label>
                              </div>



                              {/* Terms Checkbox */}
                              <div className="md:col-span-3">
  <div className="flex items-start space-x-3 mb-2">
    <input
      type="checkbox"
      id="termsCheckbox"
      checked={isTermsChecked} // Separate state for terms
      onChange={toggleTermsCheckbox} // Separate handler for terms
      className="mt-1 h-5 w-5 text-primary-color focus:ring-primary-color"
    />
    <label htmlFor="termsCheckbox" className="text-sm black">
      Je déclare avoir pris connaissance de {' '}
      <a href="/terms" className="text-primary-color underline hover:underline">
        termes et conditions
      </a>
    </label>
  </div>

  <div className="flex items-start space-x-3">
    <input
      type="checkbox"
      id="privacyCheckbox"
      checked={isPrivacyChecked} // Separate state for privacy
      onChange={togglePrivacyCheckbox} // Separate handler for privacy
      className="mt-1 h-5 w-5 text-primary-color focus:ring-primary-color"
    />
    <label htmlFor="privacyCheckbox" className="text-sm black">
    Je déclare avoir pris connaissance de {' '}
    {' '}
      <a href="/politiques" className="text-primary-color underline hover:underline">
        la politique de confidentialité
      </a>{' '}
     et je donne mon consentement au traitement de mes données personnelles selon cette politique
    </label>
  </div>
</div>

                              {/* Submit Button */}
                              <div className="md:col-span-3 mt-6">
                                <button
                                  type="submit"
                                  
                                  disabled={!isTermsChecked || !isPrivacyChecked || !isCaptchaChecked || loeading}
                                  className={`w-full py-3 px-6 bg-primary-color text-white font-medium rounded-lg transition-all
                                  ${!isTermsChecked || !isPrivacyChecked || !isCaptchaChecked || loeading
                                      ? 'opacity-50 cursor-not-allowed'
                                      : 'hover:bg-primary-color-dark transform hover:scale-105'}
                                `}
                                >
                                  {t("checkout.form.sendbtn")}
                                </button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </>
              ) : (
                <>
                  <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-center">
                      <h6 className="text-blueGray-700 text-2xl font-bold">
                        {t("checkout.generate")}
                      </h6>
                    </div>
                  </div>
                  <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                    {/*formik form*/}
                    <Formik
                      initialValues={{
                        livraison: false,
                        email: "",
                        name: "",
                        phone: "",
                        address: "",
                      }}
                      onSubmit={(values, formikBag) => {
                        createOrder(values, formikBag);
                      }}
                      validationSchema={
                        i18n.language === "fr"
                          ? CreateOrderSchema
                          : CreateOrderSchema_ar
                      }
                    >
                      {({ errors, touched }) => (
                        <Form dir="rtl"> {/* Added dir="rtl" for right-to-left layout */}
                        <div className="max-w-4xl mx-auto p-6">
                          <h2 className="text-2xl font-bold text-primary-color mb-8">
                            {/* {t("checkout.form.title")} */}
                            نموذج التسجيل
                          </h2>
                      
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Name Field */}
                            <div className="space-y-2">
                              <label className="block text-sm font-medium text-gray-700">
                                {/* {t("checkout.form.fullName")} */}
                                الاسم الكامل *
                              </label>
                              <Field name="name">
                                {({ field, meta }) => (
                                  <div>
                                    <input
                                      {...field}
                                      type="text"
                                      placeholder="الاسم واللقب"
                                      className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-color focus:border-primary-color transition-all"
                                    />
                                    {meta.touched && meta.error && (
                                      <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>
                      
                            {/* Email Field */}
                            <div className="space-y-2">
                              <label className="block text-sm font-medium text-gray-700">
                                {/* {t("checkout.form.email")} */}
                                البريد الإلكتروني
                              </label>
                              <Field name="email">
                                {({ field, meta }) => (
                                  <div>
                                    <input
                                      {...field}
                                      type="email"
                                      placeholder="example@gmail.com"
                                      className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-color focus:border-primary-color transition-all"
                                    />
                                    {meta.touched && meta.error && (
                                      <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>
                      
                            {/* Phone Field */}
                            <div className="space-y-2">
                              <label className="block text-sm font-medium text-gray-700">
                                {/* {t("checkout.form.phone")} */}
                                رقم الهاتف *
                              </label>
                              <Field name="phone">
                                {({ field, meta }) => (
                                  <div>
                                    <input
                                      {...field}
                                      type="tel"
                                      placeholder="+213 5 xx xx xx xx"
                                      className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-color focus:border-primary-color transition-all"
                                    />
                                    {meta.touched && meta.error && (
                                      <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>
                      
                            {/* Address Field */}
                            <div className="space-y-2">
                              <label className="block text-sm font-medium text-gray-700">
                                {/* {t("checkout.form.address")} */}
                                العنوان *
                              </label>
                              <Field name="address">
                                {({ field, meta }) => (
                                  <div>
                                    <input
                                      {...field}
                                      type="text"
                                      placeholder="برج بوعريريج"
                                      className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-color focus:border-primary-color transition-all"
                                    />
                                    {meta.touched && meta.error && (
                                      <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>
                      
                            {/* Wilaya Field */}
                            <div className="space-y-2">
                              <label className="block text-sm font-medium text-gray-700">
                                {/* {t("checkout.form.wilaya")} */}
                                الولاية
                              </label>
                              <Field name="wilaya">
                                {({ form, meta }) => (
                                  <div>
                                    <Select
                                      options={wilaya}
                                      onChange={(value) => setVille(value)}
                                      className="w-full border rounded-lg focus:ring-2 focus:ring-primary-color"
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          padding: '0.5rem',
                                          border: 'none',
                                          boxShadow: 'none'
                                        })
                                      }}
                                    />
                                    {meta.touched && meta.error && (
                                      <p className="text-red-500 text-sm mt-1">{meta.error}</p>
                                    )}
                                  </div>
                                )}
                              </Field>
                            </div>
                              {/* reCAPTCHA */}
                              <div className="space-y-2">
                                <div className="scale-110 w-[320px] h-[80px]">
                                  <ReCaptchaV2
                                    sitekey={REACT_APP_SITE_KEY}
                                    ref={recaptchaRef}
                                    onChange={onChange}
                                    className="flex justify-center "
                                  />
                                </div>
                              </div>
                      
                            {/* Proxima Delivery Card */}
                            <div className="md:col-span-3 gap-4">
                              <label className="flex items-center space-x-4 cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={handleClick}
                                  className="h-5 w-5 text-primary-color focus:ring-primary-color rounded border-gray-300"
                                />
                                <div className={`p-4 rounded-lg flex items-center space-x-4 transition ${isSelected ? "bg-blue-200 border-primary-color" : "bg-white border-gray-300"
                                  }`}>
                                  <div>
                                    <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                                      توصيل
                                      <img
                                        src={proxima}
                                        alt="Proxima Delivery"
                                        className="w-16 h-16 object-contain inline-block" // Smaller, inline image
                                      />
                                      <span className="inline-block ml-2 px-2 py-1 bg-primary-color text-white text-xs rounded-full">
                                        مجاني
                                      </span>
                                    </h3>
                                  </div>
                                </div>
                              </label>
                            </div>
                      
                            {/* Terms Checkbox */}
                            <div className="md:col-span-3">
  <div className="flex items-start space-x-3 mb-2">
    <input
      type="checkbox"
      id="termsCheckbox"
      checked={isTermsChecked} // Separate state for terms
      onChange={toggleTermsCheckbox} // Separate handler for terms
      className="mt-1 h-5 w-5 text-primary-color focus:ring-primary-color"
    />
    <label htmlFor="termsCheckbox" className="text-sm black">
      أقر بأنني اطلعت على {' '}
      <a href="/terms" className="text-primary-color underline hover:underline">
        الشروط والأحكام
      </a>
    </label>
  </div>

  <div className="flex items-start space-x-3">
    <input
      type="checkbox"
      id="privacyCheckbox"
      checked={isPrivacyChecked} // Separate state for privacy
      onChange={togglePrivacyCheckbox} // Separate handler for privacy
      className="mt-1 h-5 w-5 text-primary-color focus:ring-primary-color"
    />
    <label htmlFor="privacyCheckbox" className="text-sm black">
      و {' '}
      <a href="/politiques" className="text-primary-color underline hover:underline">
        سياسة الخصوصية
      </a> وأوافق على معالجة بياناتي الشخصية وفقًا لهذه السياسة.
    </label>
  </div>
</div>
                      
                            {/* Submit Button */}
                            <div className="md:col-span-3 mt-6">
                              <button
                                type="submit"
                                disabled={!isTermsChecked || !isPrivacyChecked || !isCaptchaChecked || loeading}
                                className={`w-full py-3 px-6 bg-primary-color text-white font-medium rounded-lg transition-all
                                                        ${!isTermsChecked || !isPrivacyChecked || !isCaptchaChecked || loeading
                                    ? 'opacity-50 cursor-not-allowed'
                                    : 'hover:bg-primary-color-dark transform hover:scale-105'}
                                                      `}
                              >
                                {/* {t("checkout.form.sendbtn")} */}
                                إرسال
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                      )}
                    </Formik>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}



// put this inthe tabeldata 
{/* <div className="flex flex-col sm:flex-row justify-between mt-4">
          <div>
            <div className="flex flex-col sm:flex-row">
              <p className="font-bold uppercase text-sm mr-2">
                Validité de l'offre :
              </p>
              <p className="font-semibold uppercase text-sm">
                10 jours.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row">
              <p className="font-bold uppercase text-sm mr-2">
                Délais de livraison :
              </p>
              <p className="font-semibold uppercase text-sm">
                3 jours après réception du bon d'enlèvement.
              </p>
            </div>
          </div>
          <div className="mt-4 sm:mt-0">
            <p className="font-bold uppercase text-sm">fabriqué en algérie</p>
          </div>
        </div> */}
